export default "__VITE_ASSET__c7f0538c__"